import { combineReducers } from 'redux';
import * as types from '../actions/ActionTypes';
import WordingService from '../services/WordingService';

const initialState = {
  cnilRules: {
    digits: false,
    lowercase: false,
    min: false,
    result: false,
    max: true,
    uppercase: false,
  },
  cnilError: null,
  isSaving: false,
  passwordError: null,
  passAgainError: null,
};

const getCnilError = (errors) => {
  if (!errors.max) {
    return 'tooLong';
  }
  const arrayErrors = [];
  Object.keys(errors).forEach((key) => {
    const value = errors[key];
    if (typeof (value) === 'number' && value !== -1) {
      arrayErrors.push(value);
    }
  });
  const firstErr = Math.min(...arrayErrors);
  return Object.keys(errors).find(err => errors[err] === firstErr) || null;
};

/**
 * Object cnil rules status
 * @param state
 * @param action
 * @return {*}
 */
export const cnilRules = (state = initialState.cnilRules, action) => {
  switch (action.type) {
    case types.UPDATE_CNIL:
      return action.payload.rules;
    case types.CLEAR_CNIL:
      return initialState.cnilRules;
    default:
      return state;
  }
};

/**
 * String cnil password error
 * @param state
 * @param action
 * @return {*}
 */
export const cnilError = (state = initialState.cnilError, action) => {
  switch (action.type) {
    case types.SET_CNIL_ERROR:
      return action.payload.error;
    case types.UPDATE_CNIL:
      return getCnilError(action.payload.errors) || null;
    default:
      return state;
  }
};

/**
 * Boolean updating password
 * @param state
 * @param action
 * @return {boolean}
 */
const isSaving = (state = initialState.isSaving, action) => {
  switch (action.type) {
    case types.UPDATE_PASSWORD_PENDING:
      return true;
    case types.UPDATE_PASSWORD_SUCCESS:
    case types.UPDATE_PASSWORD_FAILURE:
      return false;
    default:
      return state;
  }
};

/**
 * String password error message
 * @param state
 * @param action
 * @return {null}
 */
export const passwordError = (state = initialState.passwordError, action) => {
  switch (action.type) {
    case types.CLEAR_INPUT_ERROR:
      return action.payload.field === 'password' ? null : state;
    case types.SET_INPUT_ERROR:
      return action.payload.field === 'password' ? WordingService.getWording('errorMessage', action.payload.error) : state;
    case types.SET_CNIL_ERROR:
      return null;
    default:
      return state;
  }
};

/**
 * String password confirm error message
 * @param state
 * @param action
 * @return {*}
 */
export const passAgainError = (state = initialState.passAgainError, action) => {
  switch (action.type) {
    case types.CLEAR_INPUT_ERROR:
      return action.payload.field === 'passAgain' ? null : state;
    case types.SET_INPUT_ERROR:
      if (action.payload.field === 'passAgain') {
        if (action.payload.error === 'empty') {
          return WordingService.getWording('errorMessage', 'passwordConfirmEmpty');
        }
        return WordingService.getWording('errorMessage', action.payload.error);
      }
      return state;
    default:
      return state;
  }
};

export default combineReducers({
  cnilRules,
  cnilError,
  isSaving,
  passwordError,
  passAgainError,
});
